import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionJudgeFinalsEntriesQueries = (requests, queryClient) => ({
    useListContestsEditionJudgeFinalsEntries: (params, options = {}) => useQuery({
        queryKey: ["contests-edition-judge-finals-entries", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionJudgeFinalsEntries(params);
        },
        ...options,
    }),
    useSaveContestsEditionJudgeFinalsEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.saveContestsEditionJudgeFinalsEntry,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-edition-judge-finals-entries"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map